import 'css-chunksrc/client/scenes/addPlanzoneResourceToProjects/projectsSelection/checkbox/styles.scss';export default {
  "checkbox": "_checkbox_ayuje_1",
  "checked": "_checked_ayuje_12"
};